import { SyntheticEvent } from 'react';

interface TextAreaProps {
  id: string;
  value?: string;
  placeholder?: string;
  minLength?: number;
  maxLength?: number;
  rows?: number;
  cols?: number;
  readOnly?: boolean;
  disabled?: boolean;
  required?: boolean;
  onClick?: (event: SyntheticEvent) => void;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
}

const TextArea = (props: TextAreaProps) => {
  const { id, className, ...otherProps } = props;

  return (
    <textarea
      className={`w-full p-2 rounded-cxs border-2 border-[#CACDD2] disabled:opacity-40 ${className}`}
      id={id}
      name={id}
      data-testid={id}
      {...otherProps}
    ></textarea>
  );
};

TextArea.defaultProps = {
  value: undefined,
  placeholder: '',
  minLength: undefined,
  maxLength: undefined,
  readOnly: false,
  disabled: false,
  rows: 5,
  cols: undefined,
  required: false,
  onClick: () => {},
  onChange: () => {},
  className: '',
};

export default TextArea;
